<template>
<div style="position: relative">

     <div class="input-group">
      <div class="input-group-prepend" v-if="type === 'origin' || this.type === 'destination'">
        <span class="input-group-text">{{ label }}</span>
      </div>

      <gmap-autocomplete
        class="form-control"
        v-if="autocompleteOptions && address.length >= 0"
        :id="'ac-' + id"
        :placeholder="placeholder"
        :aria-label="placeholder"
        :aria-describedby="'ac-' + id"
        :value="address"
        :options="autocompleteOptions"
        ref="googleAC"
        @focus.native="focusHandler"
        @blur.native="blurHandler"
        @keyup="textChangeHandler($event)"
        @place_changed="setPlaceFromGoogle">
      </gmap-autocomplete>

      <div classNA="input-group-append" v-if="type === 'general'">
        <span classNA="input-group-text" style="background-color: transparent">
          <span class="icon-icon-search-blue"></span>
        </span>
      </div>
    </div>
    <i :class="{
      'icon-icon-locate-me-gray': !geoLocationValid,
      'icon-icon-locate-me-blue': geoLocationValid,
      'right-25': (type === 'general') }"
      @click="setPlaceFromGeoLocation"></i>
    <i class="icon-icon-close-small-blue right-25"
      :class="{ 'right-45': (type === 'general') }"
      v-if="address.length > 0"
      @click="clearTextField"></i>
    <div class="dropdown-location-history text-dark"
        :class="{ 'no-left-padding': (type === 'general') }"
         v-if="textfieldFocused && address.length < 1">
        <div class="sub-header">Recent</div>
        <div v-for="(item, index) in addressHistory"
             class="item"
             :key="index"
             @mousedown="setPlaceFromHistory(item)">
            <span class="item-icon icon-icon-map-pin"><span class="path1"></span><span class="path2"></span></span>
            <span class="item-name">{{ item.address }}</span>
        </div>
    </div>

</div>
</template>
<script>
import mixinCommon from '../mixins/common'
import settings from '../config';

let intervalChecker;

export default {
  name: 'address-field',
  props: ['id', 'name', 'label', 'type', 'selectAddressItemFunc', 'placeholderAlt'],
  mixins: [mixinCommon],
  data () {
    return {
        autocompleteOptions: false,
        textfieldFocused: false,
        ignoreFocus: false,
        test: this.id,
        address2: '',
        latitude: null,
        longitude: null,
        addressHistory: []
    }
  },
  computed: {
    placeholder () {
      if (this.placeholderAlt) {
        return this.placeholderAlt;
      }
      return 'Enter location'
    },
    geoLocation () {
        return this.$store.getters['geoLocation/response'];
    }         ,
    geoLocationValid () {
        return this.$store.getters['geoLocation/valid'];
    },
    address: {
      get: function() {
        if (this.type === 'origin' || this.type === 'destination') {
         return this.$store.getters['tripPlanner/inputs'][this.type].name;
        }
        return this.address2
      },
      set: function( name ) {
        if (this.type === 'origin') {
            this.$store.commit('tripPlanner/SET_INPUT_ORIGIN_NAME', name );
        } else if (this.type === 'destination') {
            this.$store.commit('tripPlanner/SET_INPUT_DESTINATION_NAME', name );
        } else {
          this.address2 = name
        }
      }
    },
    inputs: {
      get: function() {
        return this.$store.getters['tripPlanner/inputs'][this.type] || {};
      },
      set: function( obj ) {
        if (this.type === 'origin') {
            this.$store.commit('tripPlanner/SET_INPUT_ORIGIN_NAME', obj.name );
            this.$store.commit('tripPlanner/SET_INPUT_ORIGIN_LOCATION', obj );
        } else if (this.type === 'destination') {
            this.$store.commit('tripPlanner/SET_INPUT_DESTINATION_NAME', obj.name );
            this.$store.commit('tripPlanner/SET_INPUT_DESTINATION_LOCATION', obj );
        }
      }
    },
  },
  watch: {
    address () {
			// if there are any Google autocomplete overhangs then remove. IE11 only
			if (this.address.length < 1) {
				if (jQuery('.pac-container')) { jQuery('.pac-container').hide(); }
				setTimeout(() => { if (jQuery('.pac-container')) { jQuery('.pac-container').hide(); } }, 30);
			}
    }
  },
  methods: {
    textChangeHandler (e) {
      this.address = e.target.value
    },
    focusHandler (e) {
      // console.log('focusHandler');
      this.textfieldFocused = true
      this.getAddressToHistory()
    },
    blurHandler (e) {
      // console.log('blurHandler');
      this.textfieldFocused = false
      // setTimeout(() => this.textfieldFocused = false, 150) // otherwise clicking on the history option doesnt work
    },
    setPlaceFromGoogle (place) {
      this.selectDropdownItem({
        address: place.formatted_address,
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      })
      this.addAddressToHistory(place)
    },
    setPlaceFromHistory (place) {
      this.selectDropdownItem({
        address: place.address,
        lat: place.lat,
        lng: place.lng
      })
    },
    setPlaceFromGeoLocation () {
      if (!this.geoLocationValid) {
        alert("Please enable location in your browser!");
        return;
      }
      this.selectDropdownItem({
        address: 'My location',
        lat: this.geoLocation.lat,
        lng: this.geoLocation.lng
      })
    },
    selectDropdownItem (options = {}) {
      this.ignoreFocus = true
      this.textfieldFocused = false
      this.address = options.address
      this.latitude = parseFloat(options.lat)
      this.longitude = parseFloat(options.lng)
      this.inputs = { name: options.address, lat: options.lat, lng: options.lng, type: '' }
      if (this.selectAddressItemFunc) {
        this.selectAddressItemFunc(options)
      }
    },
    getAddressToHistory () {
      if (!localStorage['address-history']) {
          localStorage['address-history'] = '[]'
      }
      if (localStorage['address-history']) {
        this.addressHistory = JSON.parse(localStorage['address-history'])
      }
    },
    addAddressToHistory (place) {
      this.getAddressToHistory()
      // do not add is already got this address in history
      if (this.addressHistory.find(x => x.address === this.address)) {
        return
      }
      this.addressHistory.unshift({
          address: this.address,
          lat: this.latitude,
          lng: this.longitude,
          timestamp: moment().unix()
      })
      let total = this.addressHistory.length
      let max = 3
      if (total > max) {
          this.addressHistory = this.addressHistory.splice(0, max)
      }
      localStorage['address-history'] = JSON.stringify(this.addressHistory)
    },
    clearTextField (e) {
      setTimeout(() => {
        if (document.getElementById('ac-' + this.id)) {
          // this.textfieldFocused = true;
          document.getElementById('ac-' + this.id).focus();
          document.getElementById('ac-' + this.id).value = '';
          this.address = '' // this is causing a problem?
          if (jQuery('.pac-container')) { jQuery('.pac-container').hide(); }
        }
      }, 100);
      return;
      // if (document.getElementById('ac-' + this.id)) {
      //   if (jQuery('.pac-container')) { jQuery('.pac-container').hide(); }
      //   document.getElementById('ac-' + this.id).focus();
      //   document.getElementById('ac-' + this.id).value = ''
      //   this.address = '' // this is causing a problem?
      // }
    }
  },
  mounted () {

    // add region & bounds bias to Google autocomplete
    VueGoogleMaps.loaded.then(() => {
      if (!window.gAutocompleteSessionToken) {
        window.gAutocompleteSessionToken = new google.maps.places.AutocompleteService();
      }
      this.autocompleteOptions = {
        bounds: settings.AUTOCOMPLETE_BOUNDS,
        sessionToken: window.gAutocompleteSessionToken,
        componentRestrictions: { country: settings.AUTOCOMPLETE_COUNTRYCODE }
      }
    })

    // load address history
    this.getAddressToHistory();

    // hack for when the google autocopmlete dropdown still appears when textfield is empty
    // this only works if there is on address lookup on the screen at any one time
    intervalChecker = setInterval(() => {
      if (this.address.length < 1 && jQuery('.pac-container').length < 2) {
        if (jQuery('.pac-container')) {
          jQuery('.pac-container').hide();
        }
      }
    }, 100);

    // only way to monitor a google maps autocomplete input is to use on(input).
    jQuery(document, '#ac-' + this.id).on('input', (e) => {
        if (e.target.id === 'ac-' + this.id) { // This picks up other events from different instances of the component, thus restrict by id match
          // console.log("*input", this.id, e.target.value)
          this.address = e.target.value
				}
    });
  },
  destroy () {
    if (intervalChecker) {
      clearInternal(intervalChecker);
    }
  }
}
</script>

<style lang="scss" scoped>
.no-left-padding {
  left: 0 !important;
}
.no-right-padding {
  right: 0 !important;
}
.right-25 {
  right: 25px !important;
  padding-right: 5px;
}
.right-45 {
  right: 45px !important;
  padding-right: 5px;
}
.dropdown-location-history {
    left:68px;
    right:0;
    position: absolute!important;
    background-color: #fff;
    z-index: 1000;
    border-radius: 2px;
    border-top: 1px solid #d9d9d9;
    font-family: Arial,sans-serif;
    box-shadow: 0 2px 6px rgba(0,0,0,0.3);
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    overflow: hidden;
}
.dropdown-location-history .sub-header {
    font-size:11px;
    background-color: #ddd;
    padding: 2px;
}
.dropdown-location-history .item {
    cursor: default;
    padding: 0 4px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    line-height: 30px;
    text-align: left;
    border-top: 1px solid #e6e6e6;
    font-size: 11px;
    // color: #333;
}
.dropdown-location-history .item:hover {
    background-color: #eee;
}
.dropdown-location-history .item .item-icon {
  width: 15px;
  height: 20px;
  margin: 1px 4px;
  display: inline-block;
}

.input-group-prepend span {
    min-width: 68px;
}
.input-group-append .input-group-text {
  padding-left: 25px;
}
[class^="icon-"] {
    position: absolute;
    top: 10px;
    right:10px;
    cursor: pointer;
    z-index: 99;
}
input[type=text] {
  padding-right: 30px;
}

@media (max-width: 640px) {
  .input-group-prepend {
    display: none;
  }
  .dropdown-location-history {
    left: 0;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/AddressField.vue